import { ExportPdfAcceptedData } from '@ph-model/export-pdf-accepted-data';

export const sanitizeDataForCsv: (data: Record<string, ExportPdfAcceptedData>[]) => Record<string, ExportPdfAcceptedData>[] = (
  data: Record<string, ExportPdfAcceptedData>[]
): Record<string, ExportPdfAcceptedData>[] => {
  const result: Record<string, ExportPdfAcceptedData>[] = [];

  data.forEach((d: Record<string, ExportPdfAcceptedData>) => {
    const obj: Record<string, ExportPdfAcceptedData> = {};

    Object.entries(d).forEach(([key, value]) => {
      if (
        typeof value === 'string' &&
        (value.startsWith('=') || value.startsWith('+') || value.startsWith('-') || value.startsWith('@'))
      ) {
        obj[key] = `‘${value}`;
      } else {
        obj[key] = value;
      }
    });

    result.push(obj);
  });

  return result;
};
